<template>
  <v-container>
    <v-dialog v-model="show" max-width="900px"
              @click:outside="$store.commit('close_edit_profile_picture_dialog')">
      <v-card>
        <v-card-title>
          عکس پروفایل
        </v-card-title>
        <v-card-text v-if="edit_value.user.profile_picture!= null" class="mt-5 px-5">
          <v-row justify="center">
            <v-col cols="12" md="9">
              <div class="px-5" v-if="!profile_pic_uploading">
                <v-img class="w-75" :src="edit_value.user.profile_picture.file"></v-img>
              </div>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" v-if="edit_value.user.profile_picture!= null"
                 link :href="edit_value.user.profile_picture.file">
            <v-icon>
              mdi-download
            </v-icon>
            دریافت
          </v-btn>
          <v-btn color="secondary"
                 @click="file_input_open">
تغییر عکس
          </v-btn>

          <v-file-input
              style="width:0px !important;"
              accept="image/png, image/jpeg, image/bmp"
              hide-input
              prepend-icon=""
              id="uploader"
              v-model="avatar"
              @change="submit_picture"
              name="profile"
          ></v-file-input>


          <v-spacer></v-spacer>
          <v-btn color="error" @click="edit">
            ثبت تغییرات
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
import {mapState} from "vuex";
import axios from "axios";

const CancelToken = axios.CancelToken;
let cancel;
export default {

  name: "EditProfilePictureDialog",
  data() {
    return {
      avatar: null,
      profile_pic_uploading: false,
    }
  },
  computed: {
    ...mapState({
      edit_value: state => state.Admin.settings.edit_user_profile_dialog,
      show: state => state.Admin.settings.edit_user_profile_picture_dialog.show,
    })
  },
  methods: {
    edit() {
      this.$store.dispatch('update_user_profile_admin', {user_id: this.edit_value.user.id})
    },
    file_input_open() {
      let fileUpload = document.getElementById('uploader')
      if (fileUpload != null) {
        fileUpload.click()
      }
    },
    submit_picture: function () {
      let formData = new FormData();
      console.log(this.file)
      this.profile_pic_uploading = true;
      formData.append('file', this.avatar);
      formData.append('type', 2)

      this.uploading = true
      let context = this
      let url = this.$store.state.base_url + '/submissions/document/upload/'
      console.log(url)
      axios.post(url,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': "token " + localStorage.getItem('token')
            },
            cancelToken: new CancelToken(function executor(c) {
              cancel = c;
            }),
            onUploadProgress: function (progressEvent) {
              this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
            }.bind(this)
          }
      ).then(function (res) {
        context.show_success = true
        context.picture_changed = true
        context.uploading = false
        context.profile_pic_uploading = false
        context.picture_url = res.data.file
        context.set_document(res.data)
        // context.$emit('is_uploading', context.uploading)
        // context.link = res.data.file
        // context.$emit('upload_succeed', res.data)
      }).catch(function (err) {
        context.show_error = true
        context.show_success = false
        context.uploading = false
        context.profile_pic_uploading = false

        context.$emit('is_uploading', context.uploading)
        context.$emit('upload_err', {err})
      });

    },
    set_document(document) {
      this.edit_value.user.profile_picture = document

      this.$store.commit('uploading_done')
      this.is_uploading = false;
    },

  }
}
</script>

<style scoped>

</style>